import { createAction, props } from '@ngrx/store';
import { MspCwmMapping } from './model';

export const loadMspCwmMappings = createAction('[MSP CWM] Load Mappings');
export const loadMspCwmMappingsSuccess = createAction(
    '[MSP CWM] Load Mappings Success',
    props<{ items: MspCwmMapping[] }>(),
);
export const loadMspCwmMappingsFailure = createAction('[MSP CWM] Load Mappings Failure', props<{ error: any }>());

export const updateMspCwmMappings = createAction('[MSP CWM] Update Mappings', props<{ items: MspCwmMapping[] }>());
export const updateMspCwmMappingsSuccess = createAction(
    '[MSP CWM] Update Mappings Success',
    props<{ items: MspCwmMapping[] }>(),
);
export const updateMspCwmMappingsFailure = createAction('[MSP CWM] Update Mappings Failure', props<{ error: any }>());
